import { RichTextDisplay } from "@tellescope/ui";
import type { RichTextBlock as RichTextBlockType } from "../../../shared/schema";
import { AsyncLinkInterceptor } from "../AsyncLinkInterceptor";

interface RichTextBlockProps {
  content: RichTextBlockType["props"]["content"];
}

export const RichTextBlock: React.FC<RichTextBlockProps> = ({ content }) => {
  // Don't render empty rich text blocks
  if (!content) return null;

  // Key forces remount when content changes, reinitializing tiptap with new content
  return (
    <AsyncLinkInterceptor>
      <RichTextDisplay key={content} content={content} className="[&>*:first-child]:mt-0 [&>*:last-child]:mb-0" />
    </AsyncLinkInterceptor>
  );
};
